import { render, staticRenderFns } from "./tap5.vue?vue&type=template&id=502fb4d4&scoped=true&"
import script from "./tap5.vue?vue&type=script&lang=js&"
export * from "./tap5.vue?vue&type=script&lang=js&"
import style0 from "./tap5.vue?vue&type=style&index=0&id=502fb4d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fb4d4",
  null
  
)

export default component.exports